import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { plans } from '../../config/plans';
import { initiateCheckout } from '../../services/stripe';
import Plan from './Plan';
import PricingGrid from './PricingGrid';
import { useNavigate } from 'react-router-dom';

interface PricingPlansProps {
  user?: { id: string } | null; // Optional user prop
}

export default function PricingPlans({ user }: PricingPlansProps) {
  const [loading, setLoading] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();

  const handlePurchase = async (plan: typeof plans[0]) => {
    if (!user) {
      navigate('/signup');
      return;
    }
    
    setLoading(plan.name);
    setError(null);

    try {
      await initiateCheckout({
        userId: user.id,
        priceId: plan.stripeProductId
      });
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to initiate purchase. Please try again.');
    } finally {
      setLoading(null);
    }
  };

  return (
    <div className="py-12 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-4 gap-4">
          {plans.map((plan) => (
            <Plan
              key={plan.name}
              name={plan.name}
              short_name={plan.short_name}
              price={plan.price}
              features={plan.features}
              isPopular={plan.popular === true}
              loading={loading === plan.name}
              error={error}
              onSelect={() => handlePurchase(plan)}
            />
          ))}
        </div>

        <div className="mt-8">
          <div className="bg-white rounded-lg shadow-lg border border-gray-200 p-6">
            <h3 className="text-2xl font-bold">1-on-1 Coaching with Mike</h3>
            <p className="mt-4 text-4xl font-bold">$5,000</p>
            <p>Get access to Mike's expertise, additional systems, and 20+ years of knowledge.
            </p>
            <p className="text-gray-600 mt-2">Email for details and an application: <a href="mailto:mike@arcadvantage.ai" className="text-blue-500">mike@arcadvantage.ai</a></p>
          </div>
        </div>
        <a name="features"></a>
        <PricingGrid />
      </div>
    </div>
  );
}